import React from "react";
import Box from "@material-ui/core/Box";
import NmLogo from "../nm_logo.png";
import AtokaLogo from "../atoka_logo.png";
import { Typography } from "@mui/material";
import { Other } from "../index";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

const lineSpace = "16px";

let securedParty;
let letterLogo;
let signedBy;

const Amendment = (props) => {
	const {
		contract,
		applicant,
		yourSincerely,
		selectedChangeTypes,
		otherTypeText,
		dealStructure,
		recordType,
		mostExpensiveAsset,
		primaryGuar,
		businessEntity,
		isCorpOnlyDeal,
	} = props;

	if (recordType === "NMEF") {
		securedParty = "North Mill Credit Trust";
		letterLogo = NmLogo;
	} else if (recordType === "Atoka") {
		securedParty = "Atoka Funding LLC";
		letterLogo = AtokaLogo;
	}

	if (isCorpOnlyDeal === true) {
		if (businessEntity === "LLC") {
			signedBy = "Member";
		} else if (businessEntity === "Corporation") {
			signedBy = "Officer";
		} else {
			signedBy = "";
		}
	} else {
		signedBy = primaryGuar;
	}

	return (
		<>
			{dealStructure === "Loan" && (
				<Box
					sx={{
						padding: "15px 30px",
						border: "1px solid #d6d6d6",
						boxShadow: "2px 4px 5px rgba(214, 214, 214, 0.75)",
					}}>
					{/* Logo */}
					<img src={letterLogo} style={{ width: 125 }} alt="" />
					<Box mb={1}>
						<Typography>Secured Party: {securedParty}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Debtor: {applicant}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Contract No: {contract}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Equipment: {mostExpensiveAsset}</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							This Amendment dated as of {moment().format("MM/DD/YYYY")} to
							Security Agreement (“Amendment”) shall amend the Security
							Agreement by and between the above Secured Party (“Secured Party”) and
							the above Debtor (“Debtor”) with reference to the above loan transaction
							(“Security Agreement”). All terms and conditions of the Security
							Agreement not inconsistent with this Amendment shall be and remain in
							full force and effect.
						</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							The applicable provisions of the above referenced Security Agreement
							and all other documents given in conjunction therewith shall now read:
						</Typography>
					</Box>
					<Box
						sx={{ marginTop: lineSpace, marginLeft: "24px", whiteSpace: "pre-wrap" }}>
						{selectedChangeTypes.map((changeType) => {
							const isOtherChangeTypeExists = changeType === Other;
							if (isOtherChangeTypeExists) {
								return (
									<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
										- {otherTypeText}
									</Typography>
								);
							}
							return (
								<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
									- {changeType}
								</Typography>
							);
						})}
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							The parties intend and agree that a carbon copy, photocopy, or facsimile
							of this document with their signature thereon shall be treated as an
							original, and shall be deemed to be as binding, valid, genuine, and
							authentic as an original-signature document for all purposes, including
							all matters of evidence and the “best evidence” rules.
						</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							IN WITNESS WHEREOF, the parties hereto have set their hands and seals to
							this Amendment and acknowledge receipt of a true copy hereof on the
							date(s) indicated below.
						</Typography>
					</Box>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>Debtor:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{applicant}</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>Secured Party:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{securedParty}</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>By:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{signedBy}</Typography>
										<Typography sx={{ ml: 2 }}>
											{moment().format("MM/DD/YYYY")}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>By:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>James Cavallaro</Typography>
										<Typography sx={{ ml: 2 }}>
											{moment().format("MM/DD/YYYY")}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			)}
			{(dealStructure.includes("Lease") || dealStructure.includes("TRAC")) && (
				<Box
					sx={{
						padding: "15px 30px",
						border: "1px solid #d6d6d6",
						boxShadow: "2px 4px 5px rgba(214, 214, 214, 0.75)",
					}}>
					{/* Logo */}
					<img src={letterLogo} style={{ width: 125 }} alt="" />
					<Box mb={1}>
						<Typography>Lessor: {securedParty}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Lessee: {applicant}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Contract No: {contract}</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							This Amendment dated as of {moment().format("MM/DD/YYYY")} to
							Lease Agreement (“Amendment”) shall amend the Lease Agreement
							by and between the above Lessor (“Lessor”) and the above Lessee
							(“Lessee”) with reference to the above lease transaction (“Lease
							Agreement”). All terms and conditions of the Lease Agreement not
							inconsistent with this Amendment shall be and remain in full force and
							effect.
						</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							The applicable provisions of the above referenced Lease Agreement and all
							other documents given in conjunction therewith shall now read:
						</Typography>
					</Box>
					<Box
						sx={{ marginTop: lineSpace, marginLeft: "24px", whiteSpace: "pre-wrap" }}>
						{selectedChangeTypes.map((changeType) => {
							const isOtherChangeTypeExists = changeType === Other;
							if (isOtherChangeTypeExists) {
								return (
									<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
										- {otherTypeText}
									</Typography>
								);
							}
							return (
								<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
									- {changeType}
								</Typography>
							);
						})}
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							The parties intend and agree that a carbon copy, photocopy, or facsimile
							of this document with their signature thereon shall be treated as an
							original, and shall be deemed to be as binding, valid, genuine, and
							authentic as an original-signature document for all purposes, including
							all matters of evidence and the “best evidence” rules.
						</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							IN WITNESS WHEREOF, the parties hereto have set their hands and seals to
							this Amendment and acknowledge receipt of a true copy hereof on the
							date(s) indicated below.
						</Typography>
					</Box>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>Lessee:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{yourSincerely}</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>Lessor:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{securedParty}</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>By:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{signedBy}</Typography>
										<Typography sx={{ ml: 2 }}>
											{moment().format("MM/DD/YYYY")}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>By:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>James Cavallaro</Typography>
										<Typography sx={{ ml: 2 }}>
											{moment().format("MM/DD/YYYY")}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			)}
			{dealStructure === "EFA" && (
				<Box
					sx={{
						padding: "15px 30px",
						border: "1px solid #d6d6d6",
						boxShadow: "2px 4px 5px rgba(214, 214, 214, 0.75)",
					}}>
					{/* Logo */}
					<img src={letterLogo} style={{ width: 125 }} alt="" />
					<Box mb={1}>
						<Typography>Lender: {securedParty}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Customer: {applicant}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Contract No: {contract}</Typography>
					</Box>
					<Box mb={1}>
						<Typography>Equipment: {mostExpensiveAsset}</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							This Amendment dated as of {moment().format("MM/DD/YYYY")} to Equipment
							Finance Agreement (“Amendment”) shall amend the Equipment Finance
							Agreement by and between the above Lender (“Lender”) and the above
							Customer (“Customer”) with reference to the above Equipment Finance Agreement
							(“EFA”). All terms and conditions of the EFA not inconsistent with this Amendment shall be and remain in
							full force and effect.
						</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							The applicable provisions of the above referenced EFA and all other documents given in conjunction therewith shall now read:
						</Typography>
					</Box>
					<Box
						sx={{ marginTop: lineSpace, marginLeft: "24px", whiteSpace: "pre-wrap" }}>
						{selectedChangeTypes.map((changeType) => {
							const isOtherChangeTypeExists = changeType === Other;
							if (isOtherChangeTypeExists) {
								return (
									<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
										- {otherTypeText}
									</Typography>
								);
							}
							return (
								<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
									- {changeType}
								</Typography>
							);
						})}
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							The parties intend and agree that a carbon copy, photocopy, or facsimile
							of this document with their signature thereon shall be treated as an
							original, and shall be deemed to be as binding, valid, genuine, and
							authentic as an original-signature document for all purposes, including
							all matters of evidence and the “best evidence” rules.
						</Typography>
					</Box>
					<Box sx={{ marginTop: lineSpace }}>
						<Typography>
							IN WITNESS WHEREOF, the parties hereto have set their hands and seals to
							this Amendment and acknowledge receipt of a true copy hereof on the
							date(s) indicated below.
						</Typography>
					</Box>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>Customer:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{applicant}</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>Lender:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{securedParty}</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>By:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>{signedBy}</Typography>
										<Typography sx={{ ml: 2 }}>
											{moment().format("MM/DD/YYYY")}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ marginTop: "24px" }}>
								<Box display="flex" flexDirection="row">
									<Typography>By:</Typography>
									<Box
										display="flex"
										flexDirection="row"
										style={{ borderBottom: "solid black 1px", marginLeft: "5px" }}>
										<Typography>James Cavallaro</Typography>
										<Typography sx={{ ml: 2 }}>
											{moment().format("MM/DD/YYYY")}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			)}
		</>
	);
};

export default Amendment;
